export const contactsData = {
  email: 'amin.deraiya.9@gmail.com',
  phone: '+91 9157521001',
  address: 'Surat, India',
  sheetAPI: 'https://sheetdb.io/api/v1/6b7sizldbb0ov',
};
